export default {
  items: [
    {
      icon: "tachometer-alt",
      link: "/",
      resource: "",
      text: "Home"
    },
    {
      icon: "hand-holding-usd",
      link: "/clients",
      resource: "clients",
      text: "Clients"
    },
    {
      icon: "project-diagram",
      link: "/projects",
      resource: "projects",
      text: "Projects"
    },
    {
      icon: "images",
      link: "/views",
      resource: "views",
      text: "Views"
    },
    {
      icon: "film",
      link: "/videos",
      resource: "videos",
      text: "Videos"
    },
    {
      icon: "camera",
      link: "/cameras",
      resource: "cameras",
      text: "Systems"
    },
    {
      icon: "map",
      link: "/maps",
      resource: "maps",
      text: "Maps"
    },
    {
      icon: "users",
      link: "/users",
      resource: "users",
      text: "Users"
    },
    {
      icon: "plug",
      link: "/admin/applications",
      resource: "applications",
      text: "Apps"
    }
    // {
    //   icon: "film",
    //   link: "/edits",
    //   resource: "edits",
    //    text: "Edits"
    // },
  ]
}